module.exports = __webpack_public_path__ + "static/media/daykalogogrande.323e0805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daykalogogrande.png
// module id = 84
// module chunks = 0